<ara-generic-dialog *transloco="let t" [titleKey]="'common.attention'" (closed)="close()">
	<div
		class="flex flex-col w-full gap-3 rounded-xl border overflow-hidden px-[1.1rem] py-[1.4rem] transition-shadow duration-[120ms] hover:shadow-[0_1px_6px_rgba(0,0,0,0.08)]"
		[style.border-color]="'rgba(var(--color-primary), 0.55)'"
		[style.background]="'rgba(var(--color-primary), 0.04)'">
		<span class="w-full text-[1.08rem] font-bold leading-snug text-gray-600 max-[1024px]:text-[1rem]">
			{{ t('tenantunitDetails.rolesView.deleteRoleWarning.title') }}
		</span>
		<span class="w-full text-[0.98rem] font-normal leading-relaxed text-gray-700">
			{{ t('tenantunitDetails.rolesView.deleteRoleWarning.text') }}
		</span>
		@if (crossTenantUnitLabels.length > 0) {
			<ara-panel
				type="warning"
				[message]="t('tenantunitDetails.rolesView.deleteRoleWarning.crossTenantUnit', { units: crossTenantUnitLabels.join(', ') })"></ara-panel>
		}
		<ara-drag-to-complete
			class="w-full block"
			[label]="t('tenantunitDetails.rolesView.deleteRoleWarning.dragConfirm')"
			(completed)="confirm()"></ara-drag-to-complete>
	</div>
</ara-generic-dialog>
